<div class="wrapper {{wrapperClass}}" #wrapper>
	<ng-content></ng-content>
</div>
